
Backbone.Validation.configure({
    labelFormatter: 'label'
});


/**
 * Phone regex:
 *     Regex tester and explainer preset with this pattern:
 *         https://regex101.com/r/pI7yO2/5
 *
 *     Matches:
 *         1-(863)-123-456
 *         1-863-123-4567
 *         +1 (863) 123-4567
 *         863-123-4567
 *         (863)-123-4567
 *         123-4567
 *         123.456.7890
 *         123-456.7890x100
 *         123-456.7890ex100
 *         123-456.7890 ext 1
 *         123-456.7890 ext-100
 *         123-456.7890-x.23
 *         123-456.7890-ex-23
 *         +14155552671
 */

_.extend(Backbone.Validation.patterns, {
    none: /.?/,
    numeric: Backbone.Validation.patterns.number,
    alpha: /^[a-zA-Z -]*$/,
    // Phone # validation - see above note.
    phone: /^(\(?\+?\(?\d\)?)?[-. ]*(\(?\d{3}\)?)?[-. ]*(\(?\d{3}\)?)[-. ]*(\(?\d{4}\)?)([-. ]*(e?xt?)[-. ]*(\d+))?$/,
    // This is the same regex that is used in validity and the validation object
    date: /^((0?\d)|(1[012]))\/([012]?\d|30|31)\/\d{1,4}$/
});

_.extend(Backbone.Validation.messages, {
    none: 'YARRRRRN!! I BE A CROCHET PIRATE',
    numeric: Backbone.Validation.messages.number,
    alpha: '{0} must be only letters, spaces and dashes.',
    phone: '{0} must be a valid phone number.',
    date: '{0} must be a valid date (mm/dd/yyyy).'
});